import React, { useState, useCallback, useEffect } from 'react';
import { Users, X, Check } from 'lucide-react';
import '../../VentasEnhanced.css';

/**
 * Modal reutilizable para seleccionar número de personas
 * Incluye numpad visual para facilitar la entrada de datos
 */
const ModalNumeroPersonas = ({
  isOpen = false,
  onConfirm = () => { },
  onCancel = () => { },
  initialValue = 0,
  title = "Número de Personas",
  label = "Personas en la mesa"
}) => {
  const [numeroPersonas, setNumeroPersonas] = useState('');
  const [inputSelected, setInputSelected] = useState(true);

  // Inicializar el valor cuando se abre el modal
  useEffect(() => {
    if (isOpen) {
      setNumeroPersonas(initialValue.toString());
      setInputSelected(true); // Seleccionar el input al abrir
    }
  }, [isOpen, initialValue]);

  // Función para manejar input del numpad
  const handleNumeroPersonasInput = useCallback((value) => {
    if (value === 'C') {
      setNumeroPersonas(prev => prev.substring(0, prev.length - 1));
      setInputSelected(false);
    } else if (value === 'CE') {
      setNumeroPersonas('');
      setInputSelected(false);
    } else if (numeroPersonas.length < 3 || inputSelected) {
      // Si el input está seleccionado, reemplazar el valor completo
      if (inputSelected) {
        setNumeroPersonas(value);
        setInputSelected(false);
      } else {
        // Si no está seleccionado, agregar al valor existente
        setNumeroPersonas(prev => prev + value);
      }
    }
  }, [numeroPersonas, inputSelected]);

  // Función para confirmar
  const handleConfirmar = () => {
    const numero = parseInt(numeroPersonas);
    if (!numeroPersonas || numero <= 0) {
      alert("Ingrese un número válido de personas");
      return;
    }
    onConfirm(numero);
  };

  // Función para cancelar
  const handleCancelar = () => {
    onCancel();
  };

  // No renderizar si no está abierto
  if (!isOpen) return null;

  return (
    <div className="enhanced-modal-overlay">
      <div className="enhanced-modal">
        <div className="modal-header">
          <div className="modal-title-section">
            <Users size={24} />
            <h2>{title}</h2>
          </div>
          <button className="modal-close" onClick={handleCancelar}>
            <X size={20} />
          </button>
        </div>

        <div className="modal-body">
          <div className="input-group">
            <label>{label}</label>
            <input
              type="text"
              value={numeroPersonas}
              onChange={(e) => setNumeroPersonas(e.target.value.replace(/[^0-9]/g, ''))}
              onClick={() => setInputSelected(true)}
              readOnly
              className={`enhanced-number-input ${inputSelected ? 'selected' : ''}`}
              placeholder="0"
            />
          </div>

          <div className="enhanced-numpad">
            <div className="numpad-grid">
              {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(num => (
                <button
                  key={num}
                  className="numpad-key"
                  onClick={() => handleNumeroPersonasInput(num.toString())}
                >
                  {num}
                </button>
              ))}
              <button
                className="numpad-key function-key"
                onClick={() => handleNumeroPersonasInput('CE')}
              >
                CE
              </button>
              <button
                className="numpad-key zero-key"
                onClick={() => handleNumeroPersonasInput('0')}
              >
                0
              </button>
              <button
                className="numpad-key function-key"
                onClick={() => handleNumeroPersonasInput('C')}
              >
                ⌫
              </button>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="modal-btn secondary" onClick={handleCancelar}>
            <X size={18} />
            Cancelar
          </button>
          <button className="modal-btn primary" onClick={handleConfirmar}>
            <Check size={18} />
            Confirmar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalNumeroPersonas;